// @ts-nocheck
import api from 'api';
import { requestStarted, requestSucceeded, requestFailed } from 'store/slices/apiCalls';

const withApiCall = async (dispatch, key, callback) => {
    dispatch(requestStarted({ key }));

    try {
        const data = await callback();
        dispatch(requestSucceeded({ key }));
        return data;
    } catch (error) {
        dispatch(requestFailed({ key, error }));
        return error;
    }
};

export function getAllSharings(organisationId) {
    return async (dispatch) => withApiCall(dispatch, 'access.getAllSharings', () => api.teal.getAllSharings(organisationId));
}

export function createSharing(organisationId, sharingData) {
    return async (dispatch) => withApiCall(dispatch, 'access.createSharing', () => api.teal.createSharing(organisationId, sharingData));
}

export function getSharing(organisationId, sharingId) {
    return async (dispatch) => withApiCall(dispatch, 'access.getSharing', () => api.teal.getSharing(organisationId, sharingId));
}

export function getSharings(organisationId, userId) {
    return async (dispatch) => withApiCall(dispatch, 'access.getSharings', () => api.teal.getSharings(organisationId, userId));
}

export function getUser(organisationId, userId) {
    return async (dispatch) => withApiCall(dispatch, 'access.getUser', () => api.penly.getUser(organisationId, userId));
}

export function updateUserData(organisationId, userId, type, data) {
    return async (dispatch) => withApiCall(dispatch, 'access.updateUserData', () => api.penly.updateAccessUserData(organisationId, userId, type, data));
}

export function getFiles(organisationId, userId) {
    return async (dispatch) => withApiCall(dispatch, 'access.getFiles', () => api.penly.getFiles(organisationId, userId));
}

export function uploadFile(organisationId, acceptedFiles, rejected, type, userId, shareWithUser) {
    return async (dispatch) => {
        if (rejected.length) return alert('Fejl ved upload');

        const file = acceptedFiles[0];
        const filename = file.name;
        const fileInfo = { file, filename, type, shareWithUser };

        return withApiCall(dispatch, 'access.uploadFile', () => api.penly.uploadFile(organisationId, userId, fileInfo));
    };
}

export function deleteFile(organisationId, userId, fileId) {
    return async (dispatch) => withApiCall(dispatch, 'access.deleteFile', () => api.penly.deleteFile(organisationId, userId, fileId));
}

export function getFileBinary(organisationId, userId, fileId) {
    return async (dispatch) => withApiCall(dispatch, 'access.getFileBinary', () => api.penly.getFileBinary(organisationId, userId, fileId));
}

export function getAccessUsers(organisationId) {
    return async (dispatch) => withApiCall(dispatch, 'access.getAccessUsers', () => api.teal.getAccessUsers(organisationId));
}

export function getConversations(organisationId, userId) {
    return async (dispatch) => withApiCall(dispatch, 'access.getConversations', () => api.penly.getConversations(organisationId, userId));
}

export function createMessage(organisationId, userId, messageData) {
    return async (dispatch) => withApiCall(dispatch, 'access.createMessage', () => api.penly.createMessage(organisationId, userId, messageData));
}

export function updateMessage(organisationId, userId, conversationId, messageId, messageData) {
    return async (dispatch) => withApiCall(dispatch, 'access.updateMessage', () => api.penly.updateMessage(organisationId, userId, conversationId, messageId, messageData));
}

export function addOrderNote(organisationId, orderId, noteData) {
    return async (dispatch) => withApiCall(dispatch, 'access.addOrderNote', () => api.teal.addOrderNote(organisationId, orderId, noteData));
}

export function editOrderNote(organisationId, orderId, noteId, noteData) {
    return async (dispatch) => withApiCall(dispatch, 'access.editOrderNote', () => api.teal.editOrderNote(organisationId, orderId, noteId, noteData));
}

export function deleteOrderNote(organisationId, orderId, noteId) {
    return async (dispatch) => withApiCall(dispatch, 'access.deleteOrderNote', () => api.teal.deleteOrderNote(organisationId, orderId, noteId));
}

export function getAllMeetings(organisationId) {
    return async (dispatch) => {
        const meetings = await withApiCall(dispatch, 'access.getAllMeetings', () => api.teal.getAllMeetings(organisationId));
        return meetings?.meetings?.meetings || [];
    };
}

export function uniifyInvite(organisationId, userId) {
    return async (dispatch) => withApiCall(dispatch, 'access.uniifyInvite', () => api.penly.uniifyInvite(organisationId, userId));
}
